//* Temporary imports until recommended page is fully revamped
import { SplitScreenListBody } from '@web/components';
import { List } from '@web/molecules';
import mixedBowlImage from '../../images/product-photos/bowls/mixed_bowl_image-transparent.png';
import freshBowlImage from '../../images/product-photos/bowls/fresh_bowl_image-transparent.png';
import halfFreshBowlImage from '../../images/product-photos/bowls/half_fresh_bowl-transparent.png';
import splitScreenPromoImage from '../../images/our-food/split_screen_promo_image.jpg';
import checkIcon from '../../images/Icons/Check.png';
import beef from '../../images/Icons/Beef.png';
import chicken from '../../images/Icons/Chicken.png';
import lamb from '../../images/Icons/Lamb.png';
import turkey from '../../images/Icons/Turkey.png';
import pork from '../../images/Icons/Pork.png';
import {
  QUIZ_SUBPATH,
  INTRO_SLUG,
  PUP_NAME_SLUG,
  PUP_GENDER_SLUG,
  PUP_STATUS_SLUG,
  CALORIES_SLUG,
  ACTIVITY_SLUG,
  ALLERGIES_SLUG,
  ALLERGY_SELECTION_SLUG,
  USER_INFO_SLUG,
  RECOMMENDED_PLAN_SUBPATH,
  ADDONS_SELECTION_SUBPATH,
  CHECKOUT_SUBPATH,
  DELETE_PET_SUBPATH,
} from '../routing';

export const ROOT_SUBPATH = '/onboarding/';
export const ALL_RECIPES = ['chicken', 'beef', 'lamb', 'turkey', 'pork'];
export const levelToLabel = {
  Low: 'mellow',
  Moderate: 'active',
  High: 'very active',
};

export const PRODUCT_TYPES = {
  fresh: 'fresh',
  dry: 'dry',
  mixed: 'mixed',
  half_fresh: 'half_fresh',
};

export const STATE = {
  initial: ROOT_SUBPATH,
  intro: `${INTRO_SLUG}`,
  pupName: `${QUIZ_SUBPATH}/${PUP_NAME_SLUG}`,
  pupGender: `${QUIZ_SUBPATH}/${PUP_GENDER_SLUG}`,
  pupStatus: `${QUIZ_SUBPATH}/${PUP_STATUS_SLUG}`,
  weight: `${QUIZ_SUBPATH}/${CALORIES_SLUG}`,
  activity: `${QUIZ_SUBPATH}/${ACTIVITY_SLUG}`,
  allergies: `${QUIZ_SUBPATH}/${ALLERGIES_SLUG}`,
  allergySelection: `${QUIZ_SUBPATH}/${ALLERGY_SELECTION_SLUG}`,
  recommendedPlan: RECOMMENDED_PLAN_SUBPATH,
  submitCart: 'submit',
  extras: ADDONS_SELECTION_SUBPATH,
  userInfo: USER_INFO_SLUG,
  checkout: CHECKOUT_SUBPATH,
  deletePet: DELETE_PET_SUBPATH,
};

export const ACTION_TYPES = {
  initialLoad: 'initialLoad',
  toIntro: 'toIntro',
  toPupName: 'toPupName',
  toPupGender: 'toPupGender',
  toPupStatus: 'toPupStatus',
  toWeight: 'toWeight',
  toActivity: 'toActivity',
  toAllergies: 'toAllergies',
  toAllergySelection: 'toAllergySelection',
  toRecommendedPlan: 'toRecommendedPlan',
  toExtras: 'toExtras',
  toCheckout: 'toCheckout',
  toUserInfo: 'toUserInfo',
  customerInfoSaved: 'customerInfoSaved',
  selectedFreshRecipes: 'selectedFreshRecipes',
  selectedMixedRecipes: 'selectedMixedRecipes',
  goBack: 'goBack',
  deletePet: 'deletePet',
};

export const ACTIONS = {
  initialLoad: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.initialLoad,
  }),
  toIntro: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toIntro,
  }),
  toPupName: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPupName,
  }),
  toPupGender: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPupGender,
  }),
  toPupStatus: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toPupStatus,
  }),
  toWeight: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toWeight,
  }),
  toActivity: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toActivity,
  }),
  toAllergies: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAllergies,
  }),
  toAllergySelection: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toAllergySelection,
  }),
  customerInfoSaved: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.customerInfoSaved,
  }),
  toRecommendedPlan: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.toRecommendedPlan,
    };
  },
  toExtras: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toExtras,
  }),
  toUserInfo: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toUserInfo,
  }),
  toCheckout: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.toCheckout,
  }),
  selectedFreshRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedFreshRecipes,
      props,
    };
  },
  selectedMixedRecipes: (payload = {}, props) => {
    return {
      payload,
      type: ACTION_TYPES.selectedMixedRecipes,
      props,
    };
  },
  goBack: (payload = {}) => {
    return {
      payload,
      type: ACTION_TYPES.goBack,
    };
  },
  deletePet: (payload = {}) => ({
    payload,
    type: ACTION_TYPES.deletePet,
  }),
};

export const pathToAction = {
  [STATE.intro]: ACTIONS.toIntro,
  [STATE.pupName]: ACTIONS.toPupName,
  [STATE.pupGender]: ACTIONS.toPupGender,
  [STATE.pupStatus]: ACTIONS.toPupStatus,
  [STATE.weight]: ACTIONS.toWeight,
  [STATE.activity]: ACTIONS.toActivity,
  [STATE.allergies]: ACTIONS.toAllergies,
  [STATE.allergySelection]: ACTIONS.toAllergySelection,
  [STATE.recommendedPlan]: ACTIONS.toRecommendedPlan,
  [STATE.extras]: ACTIONS.toExtras,
  [STATE.userInfo]: ACTIONS.toUserInfo,
  [STATE.checkout]: ACTIONS.toCheckout,
};

export const STATE_TO_STEP_REFERENCE = {
  [STATE.recommendedPlan]: 0,
  [STATE.submitCart]: 1,
  [STATE.extras]: 1,
  [STATE.userInfo]: 2,
  [STATE.checkout]: 3,
};

export const unmappedStates = [STATE.initial, STATE.submitCart];

//* Temporary objects until recommended page is fully revamped
export const PLAN_SELECTION_KEY = 'PLAN_SELECTION';

const icon = {
  src: checkIcon,
  alt: 'icon image',
  height: 100,
  width: 100,
};

const IllustrationPillsData = [
  {
    component: 'illustration_pill',
    icon: {
      src: beef,
      alt: 'beef steak',
      width: 30,
      height: 20,
    },
    text: 'Beef',
    backgroundColor: 'background.white',
  },
  {
    component: 'illustration_pill',
    icon: {
      src: chicken,
      alt: 'chicken drumstick',
      width: 30,
      height: 20,
    },
    text: 'Chicken',
    backgroundColor: 'background.white',
  },
  {
    component: 'illustration_pill',
    icon: {
      src: turkey,
      alt: 'whole turkey',
      width: 30,
      height: 20,
    },
    text: 'Turkey',
    backgroundColor: 'background.white',
  },
  {
    component: 'illustration_pill',
    icon: {
      src: lamb,
      alt: 'lamb chop',
      width: 30,
      height: 20,
    },
    text: 'Lamb',
    backgroundColor: 'background.white',
  },
  {
    component: 'illustration_pill',
    icon: {
      src: pork,
      alt: 'pork chop',
      width: 30,
      height: 20,
    },
    text: 'Pork',
    backgroundColor: 'background.white',
  },
];

const splitListBodyData = {
  heading: {
    text: 'Benefits of a fresh food diet',
    level: 'h1',
    position: 'center',
    typography: 'heading1',
  },
  fontColor: 'text.primary',
  backgroundColor: 'neutral.bone',
  list: [
    {
      heading: 'IMPROVED DIGESTION & ENERGY',
      icon,
      headingLevel: 'h2',
      body: 'More digestible than kibble, giving your pup more nutrients and pep in their step.',
    },
    {
      heading: 'ALLERGY & WEIGHT CONTROL',
      icon,
      headingLevel: 'h2',
      body: "Our food helps maintain your pup's ideal weight and is great for allergies and sensitivities.",
    },
    {
      heading: 'MORE MEALTIMES TOGETHER',
      icon,
      headingLevel: 'h2',
      body: 'A fresh, whole food diet has been proven to help dogs live up to 2.5 years longer.',
    },
  ],
};

const ProductCardsCRO = {
  fresh: {
    icon: 'checkmarkSimple',
    gap: 0,
    typography: 'label2',
    iconColor: 'secondary.egg',
    items: [
      { body: 'Highest quality fresh ingredients' },
      { body: 'Great tasting, best for picky eaters' },
      { body: 'Increased longevity & visible health benefits' },
    ],
  },
  mixed: {
    icon: 'checkmarkSimple',
    gap: 0,
    typography: 'label2',
    iconColor: 'secondary.egg',
    items: [
      { body: 'Gently baked food retains nutrients' },
      { body: 'Health & longevity benefits of Fresh' },
      { body: 'Saves freezer space, easier for travel' },
    ],
  },
  halfFresh: {
    icon: 'checkmarkSimple',
    gap: 0,
    typography: 'label2',
    iconColor: 'secondary.egg',
    items: [
      { body: 'More affordable Fresh benefits' },
      { body: 'Human-grade ingredients' },
      { body: 'Mix with current food' },
    ],
  },
};

export const MEAL_PREP_CRO_DATA = {
  planSelectionInfo: {
    headline: "{{pupName}}'s meal plan",
    subheadline:
      "We've created a portion and plan recommendation for a {{pupWeight}}lb active pup like {{pupName}}.",
    summaryHeadline: '',
    image: '',
    ctaText: 'Select Recipes',
    items: [
      {
        title: 'Fresh',
        label: 'Select',
        benefit: 'Most Popular',
        callout: '',
        value: 'fresh',
        description: (
          <>
            <List {...ProductCardsCRO['fresh']} />
          </>
        ),
        img: {
          src: freshBowlImage.src,
          alt: 'Fresh Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{freshPricePerWeek}}',
          discount: '{{freshDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
    ],
    collapsedItems: [
      {
        title: 'Mixed',
        label: 'Select',
        benefit: 'Best Variety',
        callout: '',
        value: 'mixed',
        description: (
          <>
            <List {...ProductCardsCRO['mixed']} />
          </>
        ),
        img: {
          src: mixedBowlImage.src,
          alt: 'Mixed Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{mixedPricePerWeek}}',
          discount: '{{mixedDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
      {
        title: 'Half fresh',
        label: 'Select',
        benefit: 'Budget Friendly',
        callout: '',
        value: 'half_fresh',
        description: (
          <>
            <List {...ProductCardsCRO['halfFresh']} />
          </>
        ),
        img: {
          src: halfFreshBowlImage.src,
          alt: 'Mixed Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{halfFreshPricePerWeek}}',
          discount: '{{halfFreshDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
    ],
    mobileCtaText: 'Select Recipes',
    desktopCtaText: 'Select Recipes',
    modals: [],
    notSelectableText: '',
  },
  planSelectionInfoRecommendedPage: {
    headline: "Choose {{pupName}}'s meal plan",
    subheadline:
      'There are many plans that can work for your pup, select the option below that works best for you.',
    summaryHeadline: '',
    image: '',
    ctaText: 'Select Recipes',
    items: [
      {
        title: 'Fresh',
        label: 'Select',
        benefit: 'Most Popular',
        callout: '',
        value: 'fresh',
        description: (
          <>
            <List {...ProductCardsCRO['fresh']} />
          </>
        ),
        img: {
          src: freshBowlImage.src,
          alt: 'Fresh Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{freshPricePerWeek}}',
          discount: '{{freshDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
      {
        title: 'Mixed',
        label: 'Select',
        benefit: 'Best Variety',
        callout: '',
        value: 'mixed',
        description: (
          <>
            <List {...ProductCardsCRO['mixed']} />
          </>
        ),
        img: {
          src: mixedBowlImage.src,
          alt: 'Mixed Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{mixedPricePerWeek}}',
          discount: '{{mixedDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
    ],
    collapsedItems: [
      {
        title: 'Half fresh',
        label: 'Select',
        benefit: 'Budget Friendly',
        callout: '',
        value: 'half_fresh',
        description: (
          <>
            <List {...ProductCardsCRO['halfFresh']} />
          </>
        ),
        img: {
          src: halfFreshBowlImage.src,
          alt: 'Mixed Bowl',
        },
        unavailableText:
          'Based on your answers, this meal plan is unavailable for {{pupName}}. Please contact our Canine Care team if you have any questions.',
        priceSymbol: '',
        showMoreDetails: false,
        pricingInfo: {
          price: '{{halfFreshPricePerWeek}}',
          discount: '{{halfFreshDiscountPricePerWeek}}',
        },
        level: 'h3',
      },
    ],
    mobileCtaText: 'Select Recipes',
    desktopCtaText: 'Select Recipes',
    modals: [],
    notSelectableText: '',
  },
  body: [
    {
      component: 'Heading',
      headingLevel: 'h3',
      headingText: 'Available recipes',
      position: 'center',
      typography: 'heading3',
    },
    {
      component: 'IllustrationPills',
      pills: IllustrationPillsData,
    },
    {
      component: 'SplitScreenPromo',
      imageFirst: false,
      image: {
        src: splitScreenPromoImage,
        alt: 'Our Recipes',
      },
      contentBgColor: 'neutral.bone',
      content: (
        <>
          <SplitScreenListBody {...splitListBodyData} />
        </>
      ),
      eyebrow: '',
    },
  ],
};

export const RECOMMENDED_PLAN_CRO_DATA = {
  imageFirst: false,
  image: {
    src: splitScreenPromoImage,
    alt: 'Our Recipes',
  },
  contentBgColor: 'neutral.bone',
  content: (
    <>
      <SplitScreenListBody {...splitListBodyData} />
    </>
  ),
  eyebrow: '',
};

// Shopify TODO: We can and should delete this post-Shopify MVP, this simplifies migration for now
export const BC_TO_SHOPIFY_SKU_MAP = {
  /* Beef & Sweet Potato Jerky Strips */
  'JERKYSTRIPS-BE': 'TRT-JERKYSTRIPS-BSP',
  /* Chicken and Apple Jerky Strips */
  'JERKYSTRIPS-CH': 'TRT-JERKYSTRIPS-CA',
  /* Salmon and Coconut Jerky Strips */
  'JERKYSTRIPS-SA': 'TRT-JERKYSTRIPS-SC',
  /* Peanut Butter Frozen Treat */
  'FR-ICECREAM-PBB': 'TRT-FROZENTREAT-PB',
  /* Crunchy Treats with Sweet Potato */
  'TREAT-SWEETPOTATOCRNCH-08': 'TRT-CRUNCHY-SP',
  /* Crunchy Treats with Apple & Mixed Berry */
  'TREAT-APPLECRNCH-08': 'TRT-CRUNCHY-AMB',
  /* Training Treats with Parmesan */
  'TREAT-PARMTRAINING-08': '',
  /* Training Treats with Peanut Butter */
  'TREAT-PBTRAINING-08': '',
  /* Skin & Coat Chews */
  'SUPP-SKIN': 'SPPL-SKINCOAT',
  /* Probiotic Chews */
  BELLYRUBS01: 'SPPL-PROBIOTIC',
  /* Hip & Joint Chews */
  ZOOMIES01: 'SPPL-HIPJOINT',
  /* Calming Chews */
  CHILLPILLS01: 'SPPL-CALMING',
  /* Dental Chews */
  'SUPP-DENT-XS': 'DC-DENTALCHEWS-XS',
  'SUPP-DENT-SM': 'DC-DENTALCHEWS-SM',
  'SUPP-DENT-MD': 'DC-DENTALCHEWS-MD',
  'SUPP-DENT-LG': 'DC-DENTALCHEWS-LG',
};

// Same as above, just reversed
export const SHOPIFY_TO_BC_SKU_SMAP = {
  /* Beef & Sweet Potato Jerky Strips */
  'TRT-JERKYSTRIPS-BSP': 'JERKYSTRIPS-BE',
  /* Chicken and Apple Jerky Strips */
  'TRT-JERKYSTRIPS-CA': 'JERKYSTRIPS-CH',
  /* Salmon and Coconut Jerky Strips */
  'TRT-JERKYSTRIPS-SC': 'JERKYSTRIPS-SA',
  /* Peanut Butter Frozen Treat */
  'TRT-FROZENTREAT-PB': 'FR-ICECREAM-PBB',
  /* Crunchy Treats with Sweet Potato */
  'TRT-CRUNCHY-SP': 'TREAT-SWEETPOTATOCRNCH-08',
  /* Crunchy Treats with Apple & Mixed Berry */
  'TRT-CRUNCHY-AMB': 'TREAT-APPLECRNCH-08',
  /* Training Treats with Parmesan */
  'TREAT-PARMTRAINING-08': 'TREAT-PARMTRAINING-08',
  /* Training Treats with Peanut Butter */
  'TREAT-PBTRAINING-08': 'TREAT-PBTRAINING-08',
  /* Skin & Coat Chews */
  'SPPL-SKINCOAT': 'SUPP-SKIN',
  /* Probiotic Chews */
  'SPPL-PROBIOTIC': 'BELLYRUBS01',
  /* Hip & Joint Chews */
  'SPPL-HIPJOINT': 'ZOOMIES01',
  /* Calming Chews */
  'SPPL-CALMING': 'CHILLPILLS01',
  /* Dental Chews */
  'DC-DENTALCHEWS-XS': 'SUPP-DENT-XS',
  'DC-DENTALCHEWS-SM': 'SUPP-DENT-SM',
  'DC-DENTALCHEWS-MD': 'SUPP-DENT-MD',
  'DC-DENTALCHEWS-LG': 'SUPP-DENT-LG',
};
